module.exports = __webpack_public_path__ + "img/679.5e5a8396.png";